import postWithToken from "./base/post-with-token";

const setUserRole = (role, rolePermissions) =>
  postWithToken("/user-role")({
    role,
    rolePermissions,
  });

export default setUserRole;
